module.exports = __webpack_public_path__ + "static/media/masjid_kichula5.e0f4aee1.webp";